import { Container, Button, Row, Col, Image } from 'react-bootstrap';

function Hero() {
  return (
    <div className="hero px-4 py-2 my-5 ">
      <Container>
        <Row className="align-items-center g-5 py-5">
          <Col lg={6}>
            <h1 className="display-5 fw-bold" style={{ color: '#434242' }}>
              Sebastián Menescaldi
            </h1>
            <p className="lead">
              Soy Licenciado en Economía (UCA) con un posgrado en Economía en la UTDT (sí, me gusta la economía). Hoy en día ejerzo de Director asociado en Eco Go Consultores y en IES Consultores donde me dedico al análisis de la coyuntura macro, financiera y sectorial. 
            </p>
            <div className="d-grid gap-2 d-md-flex justify-content-md-start">
              <Button variant="primary" size="lg" className="px-4 me-md-2" 
                  onClick={() => { document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });}}>
                Contacto
              </Button>
              <Button variant="outline-secondary" size="lg" className="px-4" href="/bio">
                Leer más
              </Button>
            </div>
          </Col>
          <Col lg={6}>
            <Image 
              src= "/seba_hero.jpeg" 
              className="rounded d-block mx-lg-auto img-fluid" 
              alt="Sebastian Menescaldi" 
              width="700" 
              height="500" 
              loading="lazy" 
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hero;